<template>
  <v-layout column>
    <v-row class="page-header-block">
      <h1 class="page-header-block__header">clusters</h1>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="clusters"
      :search="search"
      class="elevation-1"
      style="height: 100%"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>

          <v-spacer></v-spacer>

          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="mb-2" v-bind="attrs" v-on="on" @click="resetDialog">Add Cluster</v-btn>
            </template>

            <v-card>
              <validation-observer v-slot="{ handleSubmit }">
                <form @submit.prevent="handleSubmit(save)">
                  <v-card-title class="headline grey lighten-2" primary-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <warning :messages="warningMessages"></warning>
                      <v-row>
                        <v-col>
                          <validation-provider
                            :vid="uuid()"
                            name="Host"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-text-field label="Host" v-model="editedCluster.host"></v-text-field>

                            <span class="validation-message">{{ errors[0] }}</span>
                          </validation-provider>
                        </v-col>

                        <v-col cols="6">
                          <validation-provider
                            :vid="uuid()"
                            name="Username"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-text-field label="Username" v-model="editedCluster.username"></v-text-field>

                            <span class="validation-message">{{ errors[0] }}</span>
                          </validation-provider>
                        </v-col>

                        <v-col cols="6">
                          <validation-provider
                            :vid="uuid()"
                            name="Passowrd"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              label="Password"
                              type="password"
                              v-model="editedCluster.password"
                            ></v-text-field>

                            <span class="validation-message">{{ errors[0] }}</span>
                          </validation-provider>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="resetDialog()">Cancel</v-btn>
                    <v-btn color="blue darken-1" text type="submit">Save</v-btn>
                  </v-card-actions>
                </form>
              </validation-observer>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editCluster(item, 'info')">mdi-pencil</v-icon>
        <v-icon small @click="deleteCluster(item)">mdi-delete</v-icon>
      </template>
    </v-data-table>
  </v-layout>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { assign, isEmpty } from "lodash";
import uuid from "src/mixins/uuid";
import validationRules from "src/mixins/validationRules";
import http from "src/util/http";
import Warning from "src/components/common/Warning";

export default {
  name: "Clusters",
  components: { ValidationObserver, ValidationProvider, Warning },
  mixins: [uuid, validationRules],
  data() {
    return {
      search: "",
      clusters: [],
      dialog: false,
      headers: [
        { text: "Host", value: "host" },
        { text: "Username", value: "username" },
        { text: "Password", value: "password" },
        { text: "Status", value: "status" },
        { text: "", value: "actions" },
      ],
      editedCluster: {},
      warningMessages: [],
    };
  },
  computed: {
    formTitle() {
      return isEmpty(this.editedCluster) ? "Add Cluster" : "Edit Cluster";
    },
  },
  mounted() {
    this.getClusters();

    setInterval(async () => {
      const { data: clusters } = await http().get("clusters");
      this.clusters = clusters;
    }, 10000);
  },
  methods: {
    async getClusters() {
      this.$store.dispatch("updateShowLoading", true);

      const { data: clusters } = await http().get("clusters");
      this.clusters = clusters;

      this.$store.dispatch("updateShowLoading", false);
    },
    addCluster() {
      this.dialog = true;
    },
    async deleteCluster(cluster) {
      if (
        await this.$confirm("Are you sure you want to delete this cluster?")
      ) {
        await http().delete(`clusters/${cluster.id}`);
        this.getClusters();
      }
    },
    async save() {
      if (this.editedCluster.id) {
        await http().patch(
          `clusters/${this.editedCluster.id}`,
          this.editedCluster
        );
        this.getClusters();
        this.resetDialog();
      } else {
        try {
          await http().post("clusters", this.editedCluster);
          this.getClusters();
          this.resetDialog();
        } catch (err) {
          this.warningMessages = ["Email exists"];
        }
      }
    },
    editCluster(cluster) {
      this.editedCluster = assign({}, cluster);
      this.dialog = true;
    },
    resetDialog() {
      this.dialog = false;
      this.editedCluster = {};
      this.warningMessages = [];
    },
  },
};
</script>
